import { ConfirmationDialog } from "../../../../assets/types";
import { FormatHelper } from "../../../../assets/utils/helpers";
import { Constants } from "../../../../assets/utils/lib/constants";
import { LoadingIndicator } from "../../../../assets/vfx";
import { VfxDialogProps } from "../../../../assets/vfx/dialog/vfxDialogProps";
import Drawer from "../../../../assets/vfx/drawer/drawer";
import DisplayData from "../../../common/DisplayData/DisplayData";
import AddressData from "../../../common/DisplayData/AddressData";
import { ViewProps } from "./props";
import { LookupDto } from "../../../../assets/utils/lib/lookupDto";
import { OrganizationDto } from "../../../../services/dto/nonprofit/organizationDto";

interface NonprofitOrganizationViewProps {
  data?: OrganizationDto;
  show: boolean;
  onHide: () => void;
  onEdit: () => void;
  onDelete: () => void;
  lookups?: ViewProps.OrganizationLookupProps;
  onDeactivate: () => void;
}

export const NonprofitOrganizationView = (
  props: NonprofitOrganizationViewProps
) => {
  const community: string | undefined = props.lookups?.communities.find(
    (x) => x.value === props.data?.communityId
  )?.display;

  const modalDialogProps: VfxDialogProps | undefined = props.data
    ?.deactivationDate
    ? undefined
    : new ConfirmationDialog().get(props.onDeactivate, "Deactivate", {
        Name: props.data?.name ?? Constants.emptyString,
      });
  return (
    <Drawer.View
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      onHide={props.onHide}
      onEdit={props.onEdit}
      title={"View Organization"}
      onDeactivate={
        props.data?.deactivationDate ? undefined : props.onDeactivate
      }
      modalDialogProps={modalDialogProps}
    >
      {!props.data ? (
        <LoadingIndicator isFullPage />
      ) : (
        <>
          <DisplayData text="Name" importedData={props.data?.name} />
          <DisplayData text="Summary" importedData={props.data?.summary} />
          <DisplayData text="Community" importedData={community} />
          {props.data?.webUrl && (
            <DisplayData text="Link Url" importedData={props.data?.webUrl} />
          )}
          {props?.data?.categories && (
            <DisplayData
              text="Categories"
              importedData={props?.data?.categories
                ?.map(
                  (category) =>
                    props.lookups?.category.find((x) => x.value === category)
                      ?.display
                )
                .filter(Boolean)
                .join(", ")}
            />
          )}
          <AddressData
            text="Address"
            AddressLine1={props.data?.addressLine1}
            AddressLine2={props.data?.addressLine2}
            City={props.data?.city}
            State={
              LookupDto.getLookupById(
                props?.lookups?.state,
                props?.data?.stateId
              )?.code ?? Constants.emptyString
            }
            ZipCode={props?.data?.zip}
          />
          {props.data?.contactName && (
            <DisplayData
              text="Contact Name"
              importedData={props.data?.contactName}
            />
          )}
          {props.data?.contactPhone && (
            <DisplayData
              text="Contact Phone"
              importedData={props.data?.contactPhone}
            />
          )}
          {props.data?.contactEmail && (
            <DisplayData
              text="Contact Email"
              importedData={props.data?.contactEmail}
            />
          )}
          {props.data?.logo && (
            <DisplayData
              isImage={true}
              text="Image"
              importedData={props.data?.logo}
            />
          )}
          <DisplayData
            text="Activation Date"
            importedData={
              props.data?.activationDate
                ? FormatHelper.formatDate(props.data?.activationDate)
                : Constants.emptyString
            }
          />
          {props.data?.deactivationDate && (
            <DisplayData
              text="De-Activation Date"
              importedData={FormatHelper.formatDate(
                props.data?.deactivationDate
              )}
            />
          )}
        </>
      )}
    </Drawer.View>
  );
};
